<template>
<b-container>
  <h3>Quel est votre cadre de jeu</h3>
  <b-form-group v-for="q in questions" :key="q.key" :label="$t(q.key+'.label')">
      <b-form-checkbox-group stacked :id="q.key" :name="q.key" v-model="self[q.key]" @input="$v[q.key].$touch()" :class="{ error: $v[q.key].$error }">
          <b-form-checkbox  v-for="v in q.values" :key="v" :value="v" >{{$t(q.key+'.'+v)}}</b-form-checkbox>
      </b-form-checkbox-group>
  </b-form-group>

<b-form-group class="action">
   <div class="float-left">   <b-button variant="outline-primary" to="/">&lt; Précédent</b-button></div>
  <div class="float-right"><b-button variant="outline-primary" to="/section2" :disabled="$v.$invalid">Suivant &gt;</b-button></div>
</b-form-group>

</b-container>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { required } from "vuelidate/lib/validators";
export default {
  name: "Section1",

  data() {
    return {
      questions: [
        {
          key: "seeking",
          values: ["pronostics", "advices", "infotools", "learn"]
        },
        {
          key: "favoriteMedia",
          values: ["sms", "phone", "email", "web", "paper"]
        },
        {
          key: "operator",
          values: [
            "pmuOffline",
            "pmuOnline",
            "zeturf",
            "betclic",
            "genybet",
            "leturf",
            "other"
          ]
        }
      ]
    };
  },
  validations: {
    seeking: { required },
    favoriteMedia: { required },
    operator: { required }
  },

  // beforeRouteLeave(to, from, next) {
  //   console.log(to, from)
  //   if (to.meta.rank < from.meta.rank) {
  //     next();
  //   }
  //   if (this.$v && !this.$v.$invalid) {
  //     next(); // go to the next route if no error
  //   }
  // },
  computed: {
    self() {
      return this;
    },
    // When using nested data structures, the string
    // after the last dot (e.g. `firstName`) is used
    // for defining the name of the computed property.
    ...mapFields([
      "answers.createdAt",
      "answers.seeking",
      "answers.favoriteMedia",
      "answers.operator"
    ])
  }
};
</script>

<style scoped>
</style>